import { get } from 'lodash';
import userMixin from './user';

export default {
  mixins: [userMixin],
  methods: {
    hasAccessEmployee(employee) {
      const company = employee.company || {};
      const parentId = get(employee, 'company.parent.id', 0);
      return this.iHaveAccess('MAIN.EMPLOYEE.READ') &&
        (this.amISystemAdmin || this.isMyCompany(company.id) || this.isMyCompany(parentId));
    },
    canICreateEmployee(companyId = null) {
      const haveAccess = this.iHaveAccess('MAIN.EMPLOYEE.CREATE');
      if (companyId === null) {
        return haveAccess;
      }

      return haveAccess &&
        (this.amISystemAdmin || this.isMyCompany(companyId));
    },
    canIEditEmployee(employee) {
      return this.iHaveAccess('MAIN.EMPLOYEE.UPDATE') &&
        this.hasAccessEmployee(employee);
    },
    canIDeleteEmployee(employee) {
      return this.iHaveAccess('MAIN.EMPLOYEE.DELETE') &&
        this.hasAccessEmployee(employee);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/employee.js